import React from 'react';
import ArticleLayout, { Labeled } from '../components/site/ArticleLayout';
import useLang from '../i18n/useLang';
import BlogAIimage from '../images/BlogAI.jpg';

const BlogAI = () => {
  const { t } = useLang();

  return (
    <ArticleLayout
      title={t('blogs.blogAI.header1')}
      image={BlogAIimage}
      imageAlt={t('blogs.blogAI.header1')}
      imagePosition="object-top"
      author={t('blogs.blogMaimPage.Yaniv')}
      date="2024-11-15"
    >
      <p>{t('blogs.blogAI.IntroParagraph')}</p>

      <h2>{t('blogs.blogAI.header2')}</h2>
      <ul>
        <li><Labeled text={t('blogs.blogAI.feature1')} /></li>
        <li><Labeled text={t('blogs.blogAI.feature2')} /></li>
        <li><Labeled text={t('blogs.blogAI.feature3')} /></li>
        <li><Labeled text={t('blogs.blogAI.feature4')} /></li>
      </ul>

      <h2>{t('blogs.blogAI.header3')}</h2>
      <p>{t('blogs.blogAI.benefitsIntro')}</p>
      <ol>
        <li><Labeled text={t('blogs.blogAI.benefit1')} /></li>
        <li><Labeled text={t('blogs.blogAI.benefit2')} /></li>
        <li><Labeled text={t('blogs.blogAI.benefit3')} /></li>
        <li><Labeled text={t('blogs.blogAI.benefit4')} /></li>
      </ol>

      <h2>{t('blogs.blogAI.header4')}</h2>
      <p>{t('blogs.blogAI.industry4Paragraph')}</p>

      <h2>{t('blogs.blogAI.header5')}</h2>
      <p>{t('blogs.blogAI.conclusionParagraph')}</p>
    </ArticleLayout>
  );
};

export default BlogAI;
